export default "<div>\n  <kz-files-table model=\"model\" doc-id=\"eventId\" ng-if=\"model\"></kz-files-table>\n</div>\n";